import moment from 'moment'

export const dateFormat = (date) => {
  return moment(date).format('Y年M月D日(ddd)')
}
export const dateFormatYYYYMMDD = (date) => {
  return moment(date).format('YYYY-MM-DD')
}

export const dateTimeFormat = (date) => {
  return moment(date).format('Y年M月D日(ddd) H時mm分')
}

export const priceYenFormat = (amount) => {
  return isNaN(amount)
    ? amount
    : Math.floor(Number(amount)).toLocaleString() + '円'
}

export default {
  methods: {
    dateFormat(date) {
      return dateFormat(date)
    },
    dateTimeFormat(date) {
      return dateTimeFormat(date)
    },
    priceYenFormat(amount) {
      return priceYenFormat(amount)
    }
  }
}
